<template>
    <div class="body_content" v-if="!disabled">

        <el-row class="row title_wrapper">
            <el-button @click="backToPrePage" class="back_button"><i class="el-icon el-icon-arrow-left"></i></el-button>
            <label class="reset_password_title">{{$t('resetPassword.confirmSendEmailTitle')}}</label>
        </el-row>

        <el-row class="confirm_email_description_wrapper">
            <div class="row">
                <p class="email_confirm_was_send_to">{{$t('resetPassword.emailConfirm')}}</p>
                <p class="email_to_send">{{endUserEmail}}</p>
                <p class="send_to">{{$t('resetPassword.sendTo')}}</p>
            </div>
            <p class="visit_your_email_notification">{{$t('resetPassword.pleaseVisitLinkNotification')}}</p>
        </el-row>

        <el-row class="back_to_login_button_wrapper">
            <el-button @click="backToLoginPage" class="back_to_login_button">{{$t("resetPassword.backToLoginButton")}}
            </el-button>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "SendEmailResetPassword",
        data() {
            return {
                disabled: true,
                endUserEmail: "abc@gmail.com"
            }
        },
        created() {
            this.disabled = true;
        },
        methods: {
            backToPrePage() {
                this.$router.go(-1);
            },
            backToLoginPage() {
                this.$router.push({path: "/login"});
            },
            setDisable(disabled){
                this.disabled = disabled;
            },
            setEndUserMail(endUserMail){
                this.endUserEmail = endUserMail;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .body_content {
        width: 40%;
        margin-left: 30%;
    }

    .title_wrapper {
        margin-top: 50px;
    }

    .back_button:hover {
        background-color: white;
    }

    .back_button {
        border: none;
        margin-left: -20px;
        position: absolute;
        cursor: pointer;
        font-size: 30px;
        font-weight: bold;
        z-index: 1;
    }

    .reset_password_title {
        font-weight: bold;
        font-size: 30px;
        position: relative;
        display: inline-block;
        width: calc(80% - 50px);
        margin: 0 calc(10% + 25px);
        text-align: center;
    }

    .confirm_email_description_wrapper {
        margin-top: 2%;
        margin-left: 12%;
    }

    .email_confirm_was_send_to {
        margin-right: 5px;
    }

    .email_to_send {
        font-weight: bold;
        margin-right: 5px
    }

    .visit_your_email_notification {
        font-weight: normal
    }

    .back_to_login_button_wrapper {
        margin-top: 15%;
        text-align: center;
        width: 100%
    }

    .back_to_login_button {
        width: 60%
    }

    @media only screen and (max-width: 1024px) {
        .body_content {
            width: 100%;
            margin-left: 0%;
            margin-right: 0%
        }
    }

    @media only screen and (max-width: 450px){
        .body_content{
            width: 100%;
            margin-left: 0%;
            margin-right: 0%
        }

        #title_wrapper{
            margin-right: 0%;
            margin-left: 0%
        }

        .back_button {
            width: 10%;
            text-align: left!important;
            float: left;
            font-size: 100%;
        }
    }
</style>